define('formkit/behavior/template.object.type.counters.behavior',['require','exports','module','marionette'],function(require, exports, module) {
  var Mn = require('marionette');

  var TemplateObjectTypeCounters = Mn.Behavior.extend({
    defaults: {
      form: null
    },

    initialize: function() {
      this.listenToOnce(this.view, 'before:render', function() {
        if (this.getOption('form')) {
          this.getOption('form').enableTemplateObjectTypeCounters();
        }
        else if (this.view.form) {
          this.view.form.enableTemplateObjectTypeCounters();
        }
      });
    }
  });

  module.exports = TemplateObjectTypeCounters;
});

